package org.gstechnovos.jexonplastech.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

class SitePalette(
    val nearBackground: Color,
    val brand: Brand,
    val custom: Custom
) {
    class Brand(
        // --- 10% ACTION COLORS (Red & Blue from Logo) ---
        // Reserved for "View Catalog" and "Inquire About This Product" CTAs [cite: 39, 57]
        val actionRed: Color = Color.rgb(0xD32027), // From the bottom swoosh
        val actionRedHover: Color = Color.rgb(0xB01A20),
        val primaryBlue: Color = Color.rgb(0x005B9F), // From the top swoosh
        val primaryBlueHover: Color = Color.rgb(0x004A82),

        // --- 30% SECONDARY COLORS (Soft Backgrounds) ---
        // For product grids and alternating sections
        val primarySoft: Color = Color.rgb(0xE6F0F7),
    )

    class Custom(
        // --- 30% SECONDARY COLORS (Typography) ---
        // Extracted from "JEXON" text for readability
        val darkText: Color = Color.rgb(0x262626),
        val lightText: Color = Color.rgb(0x999999), // Extracted from "PLASTECH"

        // --- 60% DOMINANT COLORS ---
        // Clean negative space for B2B readability
        val lightGray: Color = Color.rgb(0xF8F9FA),
        val white: Color = Colors.White,

        // Structural borders (e.g., Specs Table) [cite: 59]
        val divider: Color = Color.rgb(0xE2E8F0)
    )
}

object SitePalettes {
    val light = SitePalette(
        nearBackground = Color.rgb(0xF4F6FA),
        brand = SitePalette.Brand(),
        custom = SitePalette.Custom()
    )
}

fun ColorMode.toSitePalette(): SitePalette = SitePalettes.light

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.config.initialColorMode = ColorMode.LIGHT

    // Enforce the 60% dominant white background and 30% dark gray text globally
    ctx.theme.palettes.light.background = Colors.White
    ctx.theme.palettes.light.color = Color.rgb(0x262626)
}